import { render, staticRenderFns } from "./overlay-loader.vue?vue&type=template&id=dd63c868&"
import script from "./overlay-loader.vue?vue&type=script&lang=js&"
export * from "./overlay-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports